import { render, staticRenderFns } from "./contractDetail.vue?vue&type=template&id=6b16d94f"
import script from "./contractDetail.vue?vue&type=script&lang=js"
export * from "./contractDetail.vue?vue&type=script&lang=js"
import style0 from "./contractDetail.vue?vue&type=style&index=0&id=6b16d94f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports